import { useBackendApi } from "@/hooks/fetch";
import useSWR from "swr";
import type { CaErrorResp } from "./types";

type Params = Record<string, string | number | undefined>;

/**
 * SWR wrapper for /vanta/console/<action>
 */
export function useConsoleApi<T>(action: string, params: Params, refreshMs: number, enabled = true) {
    const api = useBackendApi<T | CaErrorResp>({
        method: 'GET',
        path: `/vanta/console/${action}`,
    });
    const cleanParams: Params = {};
    for (const [k, v] of Object.entries(params)) {
        if (v !== undefined && v !== '') cleanParams[k] = v;
    }
    const key = enabled ? `/vanta/console/${action}?${new URLSearchParams(cleanParams as Record<string, string>).toString()}` : null;
    return useSWR(key, async () => {
        const data = await api({ queryParams: cleanParams });
        if (!data) throw new Error('empty_response');
        if (typeof data === 'object' && 'error' in data) throw new Error(data.error);
        return data as T;
    }, {
        refreshInterval: refreshMs,
        revalidateOnFocus: false,
        keepPreviousData: true,
    });
}
